import { css } from 'styled-components';

export type FastCssProps = {
    position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
    display?: 'inline' | 'block' | 'flex' | 'grid' | 'inline-block' | 'inline-flex' | 'inline-grid';
    margin?: string;
    padding?: string;
    textAlign?: 'center' | 'left' | 'right';
};

export const FastCss = css<FastCssProps>`
    ${(props) => props.position && `position: ${props.position}`};
    ${(props) => props.display && `display: ${props.display}`};
    ${(props) => props.margin && `margin: ${props.margin}`};
    ${(props) => props.padding && `padding: ${props.padding}`};
    ${(props) => props.textAlign && `text-align: ${props.textAlign}`};
`;
